<template>
  <div id="vehicles" class="flex column wrap justify-center grow-1">
    <Reminders />
    <h2 class="title">LISTADO DE VEHÍCULOS</h2>
    <div class="flex justify-space-between column-sm justify-space-between-m">
      <AvailableBalanceCard :vehicle-id="selectedVehicleId" />
      <PersonalInformation />
      <BillingInformation />
    </div>
    <div class="flex wrap row justify-stretch justify-space-evenly-sm">
      <CarCard
        v-for="car in vehicles"
        :key="car.id"
        :car="car"
        @selectVehicle="changeSelectedVehicle"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AvailableBalanceCard from '@/components/AvailableBalanceCard'
import BillingInformation from '@/components/Vehicles/BillingInformation'
import CarCard from '@/components/Vehicles/CarCard'
import PersonalInformation from '@/components/Vehicles/PersonalInformation'
import Reminders from '@/components/Vehicles/Reminders'

export default {
  name: 'Vehicles',
  components: {
    AvailableBalanceCard,
    BillingInformation,
    CarCard,
    PersonalInformation,
    Reminders
  },
  data () {
    return {
      selectedVehicleId: 0
    }
  },
  computed: {
    ...mapGetters('vehicles', [
      'vehicles'
    ])
  },
  methods: {
    ...mapActions('vehicles', [
      'getVehiclesList'
    ]),
    changeSelectedVehicle (id) {
      this.selectedVehicleId = id
    }
  },
  beforeMount: function () {
    this.getVehiclesList()
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#vehicles {
  margin: 1rem 2rem;
}

.title {
  text-align: start;
  color:$grey;
}
</style>
